import { useState } from 'react';

export const useTrafftModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  const openTrafftModal = () => setIsOpen(true);
  const closeTrafftModal = () => setIsOpen(false);
  
  return { isOpen, openTrafftModal, closeTrafftModal };
};